// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DNTP","type":"styles_type__3te2i","choices":"styles_choices__2eWRl"};